<template>
  <section id="homepage">

    <h3 class="section_title">Welcome!</h3>
    
    <div class="container">

      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          
        
          <div class="opening_text">

            <h5 class="text-center">The best of What to Do, What to Love, and What to Know in Dayton</h5>

            <div class="lead_image">
              <img src="https://www.dayton.com/rf/image_large/Pub/p11/Dayton/2020/01/06/Images/DDC_VoteNOW_LeadRelatedObject_169.jpg" alt="">
            </div>

            <!-- SAMPLE VIDEO EMBED FROM ANVATO "SHARE" -->
            <!-- <div class="video_iframe_container">
              <iframe scrolling="no" frameborder="0" allowfullscreen webkitallowfullscreen mozallowfullscreen allow="autoplay; fullscreen" src="https://w3.cdn.anvato.net/player/prod/v3/anvload.html?key=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" 
              width ="100%" 
              :height="$mq | mq({mobile: 290, laptop: 400, desktop: 450})" 
              style="width: 100%"
              ></iframe>
            
            </div> -->

            <h4>Vote for all your favorite businesses, local professionals, food, and more!</h4>

            <div style="background: yellow;padding: 1em;margin: 1em 0;"
            v-if="editors_note_active"
            >
              <h3>EDITOR'S NOTE</h3>

              <p>
                Best of Dayton <strong>VOTING is back!</strong></p>
              

              <p>
              We launched voting for Dayton.com's Best of 2018 contest on Wednesday, Dec. 5., and within hours, our servers were overwhelmed by the volume of votes. Many users experienced difficulty casting votes or being able to progress from one category to another.</p>

              <p>
              We've been working around the clock to resolve this issue and have made some upgrades to help improve the voting experience.</p>

              <p>
              The contest has resumed, and we are extending the voting period through Dec. 26 to give everyone a few extra days of voting.</p>

              <p>
              Any votes cast on Dec. 5 were recorded and will still count toward the total. </p>

              <p>
              Happy voting!</p>

              <p>
              Please contact us at <a href="mailto:contact@dayton.com">contact@dayton.com</a> if you have any questions or issues.</p>

              <!-- <p>
                Some users may experience issues casting their votes in Best of Dayton. We're doing some upgrades to our servers right now to make sure everyone can get their votes in. We'll let you know when voting is up and running again and we appreciate your patience while we're working on this.
              </p> -->
            </div>

            <div class="row">

              <!-- MAIN CONTENT -->
              <div class="col-12 order-last col-lg-6 order-lg-first">
                
                <p>Here's how you can participate:</p>

                <ol>
                  <li><strong>Nominate</strong> your favorite businesses, professionals, service providers, food, and more during the nomination period.</li>
                  <li>When voting starts... <strong>VOTE!</strong> Come back and vote every day and tell everyone you know to do the same. All votes matter!</li>
                  <li>There are <strong>over 150 categories</strong> this year, so remember to check out several to support everyone you might want to vote for.</li>
                </ol>

              </div>

              <!-- RIGHT RAIL -->
              <div class="col-12 order-first col-lg-6 order-lg-last">
                
                <!-- COUNTDOWN -->
                <div class="responsive_container_zzz"
                :class="$mq">
                  <countdown-to-next-event></countdown-to-next-event>
                </div>

                <div class="responsive_container_zzz"
                :class="$mq"
                v-if="instance_period == 'Nomination Period'"
                >
                  <large-centered-button
                  button_text="Nominate Now"
                  icon="clipboard-check"
                  width="full"
                  @button_clicked="goto_path('nominate')"
                  ></large-centered-button>
                </div>

                <div class="responsive_container_zzz"
                :class="$mq"
                v-if="instance_period == 'Voting Period'"
                >
                  <large-centered-button
                  button_text="Start Voting"
                  icon="check-double"
                  width="full"
                  @button_clicked="goto_path('vote')"
                  ></large-centered-button>
                </div>

              </div>

            </div>

            

            <h4>
              Also check out some of our other great content from Dayton.com:
            </h4>

          </div>

          <story-list
          cms_list_id='0036de38-28b8-11e9-bab0-a7d3b5289767'
          ></story-list>

        </div>
      </div>
      

    </div>
  </section>
</template>

<script>
import StoryList from '@/components/lists/story_list.vue';
import LargeCenteredButton from '@/components/buttons/large_centered_button.vue';
import CountdownToNextEvent from '@/features/countdown/countdown_to_next_event.vue';
// import ResponsiveAdUnit from '@/components/ad_units/responsive_ad_unit.vue'


export default {
  name: 'homepage',
  data () {
    return {
      test_title: 'Best of Dayton 2019'
    }
  },
  computed: {
    instance_period: {
      get: function() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    editors_note_active: function() {
      let today = new Date();
      let day = today.getDate();
      let month = today.getMonth() + 1;
      let year = today.getFullYear();
      let is_active = false;

      if(year == 2018) {
        if(month == 12) {
          if(day < 10) {
            is_active = true;
          }
        }
      }

      return is_active;
    }
  },
  methods: {
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    },
    run_chartbeat: function() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function() {
      let vm = this;
      let page_title = document.title;

      if(page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      }
      else {
        setTimeout(function() {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  mounted() {
    // this.$root.googletag.cmd.push(function() { googletag.display('div-gpt-ad-1461776865768-0'); });
    document.dispatchEvent(new Event('prerender-trigger'));
    this.determine_chartbeat();
    // window.updateChartbeat(document.title, window.location.pathname);
  },
  metaInfo() {
    return {
      title: 'Welcome',
      titleTemplate: '%s | '+this.test_title,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: 'Nominate and vote for your favorite local businesses, food, people, professionals, places, and more in the 2019 Best of Dayton contest.'
        },
        {
          property: 'og:url',
          content: 'https://projects.dayton.com/best_of_dayton/'
        },
        {
          property: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          property: 'twitter:site',
          content: '@daytondotcom'
        },
        {
          property: 'og:image',
          content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg?v=2019'
        }
      ]
    }
  },
  components: {
    StoryList,
    LargeCenteredButton,
    CountdownToNextEvent,
    // ResponsiveAdUnit
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';
@import url('https://fonts.googleapis.com/css?family=Pathway+Gothic+One');

#homepage {

  .lead_image {
    width: 100%;
    margin-bottom: 1.4rem;

    img {
      width: 100%;
    }
  }

  .responsive_container {

    &.laptop, &.desktop {
      width: 50%;
      margin: 0 auto;
    }
  }

}

.opening_text {

  h5 {
    margin-bottom: 1.4rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Homepage.vue